import { CommonModule } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  TemplateRef,
} from '@angular/core'
import { RouterModule } from '@angular/router'
import { OcStyleThemeType } from 'otimus-library'
import { ContainerService } from 'src/app/services/container.service'
import { InternationalizationService } from 'src/app/services/internationalization.service'
import { MobileService } from 'src/app/services/mobile.service'
import { StyleThemeService } from 'src/app/services/style-theme.service'

@Component({
  selector: 'app-gx-container',
  imports: [CommonModule, RouterModule],
  templateUrl: './gx-container.component.html',
  styleUrl: './gx-container.component.scss',
})
export class GXContainerComponent implements AfterViewInit {
  @ContentChild('containerButton') containerButtonTpl!: TemplateRef<any>

  style: OcStyleThemeType = 'otimus'

  constructor(
    protected cdr: ChangeDetectorRef,
    public mobileService: MobileService,
    public container: ContainerService,
    public translation: InternationalizationService,
    public styleThemeService: StyleThemeService
  ) {}

  ngAfterViewInit(): void {
    this.getStyle()
    this.cdr.detectChanges()
  }

  getStyle(): void {
    const style = localStorage.getItem('@oc-lib-style_theme')

    if (!style || !['otimus', 'shui', 'semantic'].includes(style)) {
      return
    }

    this.style = style as OcStyleThemeType
  }
}
